<script setup lang="ts">
import {
  EToastType,
  TOAST_DELAY,
  useToastStore,
  type IToast,
} from '~/stores/toast'

const toastStore = useToastStore()
const { t } = useI18n()

const toastTypeConfig = computed(() => ({
  [EToastType.SUCCESS]: {
    color: 'success',
    title: t('toast.title.default.success'),
  },
  [EToastType.DANGER]: {
    color: 'error',
    title: t('toast.title.default.danger'),
  },
  [EToastType.WARNING]: {
    color: 'warning',
    title: t('toast.title.default.warning'),
  },
}))

const getToastColorByType = (toastType?: EToastType) =>
  toastType ? toastTypeConfig.value[toastType]?.color : undefined

const getToastTitleDefault = (toast: IToast) =>
  toast.title ||
  (toast.type ? toastTypeConfig.value[toast.type]?.title : undefined)

// Remove toast da store sem perder animação do coreui
const handleToastClose = (toastId: string) =>
  setTimeout(() => toastStore.removeToast(toastId), 1000)
</script>

<template>
  <div>
    <CToaster
      class="tw-p-3"
      placement="bottom-end"
      @click.stop
      @mousedown.stop
      @keydown.stop
    >
      <CToast
        v-for="toast in toastStore.toasts"
        :key="toast.id"
        :color="getToastColorByType(toast.type)"
        :delay="TOAST_DELAY"
        :data-testid="`the-toast-${toast.type}`"
        visible
        @close="handleToastClose(toast.id)"
        @click.stop
        @mousedown.stop
      >
        <CToastHeader close-button @click.stop @mousedown.stop>
          <span class="tw-me-auto tw-font-bold tw-text-base tw-up">{{
            getToastTitleDefault(toast)
          }}</span>
        </CToastHeader>
        <CToastBody :data-testid="`the-toast-body`">
          <span class="tw-text-base">{{ toast.content }}</span>
        </CToastBody>
      </CToast>
    </CToaster>
  </div>
</template>
